import {Component} from "@angular/core";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {CompanyDetailsEntityModel} from "../../company-details-entity.model";

@Component({
    selector: "wbo-company-details-edit-additional-information",
    templateUrl: "./company-details-edit-additional-information.component.html"
})
export class CompanyDetailsEditAdditionalInformationComponent {
    constructor(public model: CompanyDetailsEntityModel, public editService: EditService) {
    }
}
